import { PercentageScale } from 'src/components/VIP/PercentageScale';
import { useGetLevelInfo } from 'src/hooks/useGetLevelInfo';

export const UserLevel = () => {
  const { currentLevelName, percentageScaleValue, formattedLevelPointsString } = useGetLevelInfo();

  return (
    <div className="flex flex-col justify-center items-start gap-2">
      <p className="text-base font-bold text-as_level_name">{currentLevelName}</p>
      <PercentageScale additionalClassName="z-[2]" value={percentageScaleValue()} />
      <p className="text-xs font-medium text-as_level_points">{formattedLevelPointsString}</p>
    </div>
  );
};
